import { supabase } from "@/integrations/supabase/client";

/**
 * #1603 — remember the Kroger store she prices at, on her ACCOUNT.
 *
 * The weekly staples sweep runs on the server and checks pinned staples' stock
 * at this store. Until now the store lived only in this device's localStorage
 * (the ⭐ favorite), which the server cannot see.
 *
 * Non-fatal by design: pricing already worked, and a failed save only means
 * the next Sunday's pinned staples go on unchecked, which is #1602's behavior.
 * The write asks for its row back so a refused update is logged as a failure
 * rather than passing silently (rule 16). Nothing here shows a confirmation.
 */
export async function saveKrogerStore(
  userId: string,
  store: { id?: string | null; name?: string | null },
): Promise<{ ok: boolean; error?: string }> {
  const id = (store.id ?? "").trim();
  if (!userId || !id) return { ok: false, error: "no store" };
  const { data, error } = await supabase
    .from("user_preferences")
    // kroger_location_* are live but not yet in the generated types (#1603).
    .update({ kroger_location_id: id, kroger_location_name: (store.name ?? "").trim() || null } as never)
    .eq("user_id", userId)
    .select("user_id");
  if (error) {
    console.error(`[KrogerStore] save failed: ${error.message}`);
    return { ok: false, error: error.message };
  }
  if (!Array.isArray(data) || data.length === 0) {
    console.error("[KrogerStore] save matched no preferences row");
    return { ok: false, error: "no row" };
  }
  return { ok: true };
}
